var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":"通知"}},[_c('p',[_vm._v(_vm._s(_vm.content))]),_c('div',{staticStyle:{"font-size":"12px","text-align":"right"},attrs:{"slot":"extra"},slot:"extra"},[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }